"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserFrontDesk = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const UserFrontDesk = _ref => {
  let {
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M9.25 15.557c1.521-4.451 6.927-8.563 11.702-10.145 4.797-1.59 10.481-.316 14.247 3.403 3.766 3.72 5.602 9.285 4.469 13.974-1.102 4.702-5.037 7.531-8.501 9.26-3.485 1.736-6.5 1.742-10.096.872-3.607-.84-7.263-2.224-9.141-5.478-1.879-3.255-4.222-7.425-2.68-11.886Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M29.288 24.63v-2.515a5.1 5.1 0 0 0-1.434-3.556 4.829 4.829 0 0 0-3.46-1.473h-9.788c-1.298 0-2.542.53-3.46 1.473a5.1 5.1 0 0 0-1.434 3.556v2.514M5 37V25.333h29V37M24.393 7.029c0 2.777-2.191 5.028-4.894 5.028-2.702 0-4.893-2.251-4.893-5.028C14.605 4.25 16.796 2 19.498 2s4.894 2.251 4.894 5.029Z"
  }));
};
exports.UserFrontDesk = UserFrontDesk;
UserFrontDesk.displayName = "UserFrontDesk";